<template>
  <div
    v-if="sight.description"
    v-description-view-tracker="analyticsBase"
    class="subtitle obs-el"
    data-attr="info"
  >
    {{ sight.description }}
  </div>
</template>

<script setup lang="ts">
  import { useViewTracker } from '@/shared/lib/analytics/compat';
  import type { SightModalSight } from '@/shared/types/sight-modal';

  withDefaults(
    defineProps<{
      sight: SightModalSight;
      analyticsBase?: Record<string, unknown>;
    }>(),
    {
      analyticsBase: () => ({}),
    },
  );

  const vDescriptionViewTracker = useViewTracker('around:sights:sight-popup:description.view');
</script>

<style lang="scss" scoped>
  .subtitle {
    margin-top: var(--alias-space-20);

    @include base-400-400-regular;
  }
</style>
